import { Component } from '@angular/core';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { Subject } from 'rxjs';
import { OnInit,OnDestroy } from '@angular/core';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { Router } from '@angular/router';
import { AssetDropdownService } from 'src/app/shared/assets/assets-dropdown.service';
import { FormControl,FormGroup,FormArray,UntypedFormArray,UntypedFormControl,UntypedFormGroup, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { KeyValue } from '@angular/common';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import { ColorPickerPipe } from 'src/app/shared/assets/color-picker.pipe';
import { MatDialog } from '@angular/material/dialog';
import { TerminateSessionComponent } from 'src/app/user-login/terminate-session/terminate-session.component';
import { ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { RuleService } from 'src/app/rule/rule-custom-service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';

@Component({
  selector: 'app-create-intel-list',
  templateUrl: './create-intel-list.component.html',
  styleUrls: ['./create-intel-list.component.scss']
})
export class CreateIntelListComponent {

  constructor(
    private rcrumpService: RoutecrumpsService,
    public rulevarservice: RulevarService,
    private router:Router,
    public assetsService: AssetDropdownService,
    private ngxCsvParser: NgxCsvParser,
    public matdialog: MatDialog,
    public ruleService:RuleService,
    private toasterService: ToastService
  ) { }

  routeBack:Subject<null> = new Subject();
  next:string='NEXT'
  back:string='CANCEL'
  platformList=JSON.parse(JSON.stringify(this.assetsService.loadplatformdata()))
  add='Add row'
  openprop:boolean=false
  openIndex:number
  index:number=0
  header:boolean=false
  rawData:any
  requiredHeaders:any
  importedFields=[]
  createErrorString=''
  importErrorString=''
  manualErrorString=''
  default
  dispstr='Properties'
  @ViewChild('Popup') Popup: TemplateRef<any>;
  @ViewChild('editPopup') editPopup: TemplateRef<any>;
  @ViewChild('editWarnPopup') editWarnPopup: TemplateRef<any>;
  dialogRef:any
  destroy$: Subject<boolean> = new Subject();
  editWarn:Subject<any> = new Subject();
  disableInput:boolean=false
  mat_spinner_create_state:boolean = false;
  nameError={
    "invalidName":"Spaces and special characters are not allowed",
    "required": "List name is required",
    "maxlength": "Title doesn't exceed 200 characters",
    "intelnameAlreadyExists": "This intel list already exist"
  }
  fieldNameError={
    "invalidName":"Spaces and special characters are not allowed in field name",
    "required": "Field can't be empty",
    "minlength": "Field name should be greater than 4 characters",
  }
  aliasError={
    "invalidName":"Spaces and special characters are not allowed in alias name",
    "required": "Alias can't be empty"
    // "minlength": "Field name should be greater than 4 characters",
  }
  mode={"mode":"","i":null}
 
  

  ngOnInit(){
//console.log("edit-->",this.rulevarservice.intelEditMode)
    
    this.platformList.push({"disp":"All","value":"all"})
    this.createRouteCrumps()
    this.rulevarservice.isIntel=true
    
    if(this.rulevarservice.intelEditMode){
      this.disableInput=true
      // this.default=this.rulevarservice.jsonEdit(this.rulevarservice.intelEditValue)
      this.default=this.rulevarservice.intelEditValue
      this.remove.setValue(false)
//console.log(this.default)
    }
    else{
      this.default=this.rulevarservice.defaultIntel
    }
    

    Object.keys(this.default.createTable.table).forEach(key=>{
      if(parseInt(key) !=0)
      this.addInit(parseInt(key))
    })
    this.rulevarservice.intelForm.patchValue(this.default)

    
    this.entryMode.setValue('manual') 
    
  }

  ngAfterViewInit(){

    this.editWarn.subscribe(data=>{
      // console.log({data})
      // console.log(this.mode)
      if(this.mode.mode === 'add'){
        this.addClick(this.mode.i)
      }else if(this.mode.mode === 'remove'){
        this.removeClick(this.mode.i)
      }
      this.mode.mode=''
      this.mode.i=null
    })

    this.listName.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(name=>{

      // console.log(this.listName)
      // console.log(this.listName.valid)
      
      // if(this.rulevarservice.contextShowError.listName == true){
      //   if(name.length > 0){ 
      //     this.rulevarservice.contextValid=true
          
      //     // if(this.listName.valid){
      //       this.rulevarservice.contextShowError.listName=false
      //     }
      //     // else{
      //       this.rulevarservice.contextShowError.listName=true
      //       // this.rulevarservice.contextErrors.listName="Listname already taken"
      //     // }
      //     // this.rulevarservice.contextErrors.listName="*Listname can't be empty"
      //   }
      //   else{
      //     // this.rulevarservice.contextErrors.listName="*Listname can't be empty"
      //     this.rulevarservice.contextShowError.listName=false
      //   }
      // }
      // if(name.length>0){
        
      //   if(this.listName.valid){
      //     console.log("valid")
      //    this.rulevarservice.contextShowError.listName=false
      //     this.rulevarservice.contextErrors.listName="*Listname can't be empty"
      //   }else{
      //     console.log("Invalid")
      //     this.rulevarservice.contextShowError.listName=true
      //     this.rulevarservice.contextErrors.listName="Listname already taken"
      //   }
      // }
    })

    this.ttlValue.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(time=>{
//console.log({time})
      if(this.rulevarservice.contextShowError.TTL == true){
        if(time && time !=0){ 
          this.rulevarservice.contextShowError.TTL=false
        }
        else{
          this.rulevarservice.contextShowError.TTL=true
        }
      }
      if(time && this.learningPeriodValue.value){ 
        // console.log("<-------Ttl exists------>")
        if(time < this.learningPeriodValue.value){
          this.rulevarservice.learningTtlErr.ttl=true
          this.rulevarservice.contextValid=false
          // console.log("<--------TTL Error-------->")
        }else{
          this.rulevarservice.learningTtlErr.ttl=false
          this.rulevarservice.learningTtlErr.learning=false
          this.rulevarservice.contextValid=true
          // console.log("<--------TTL Valid-------->")
        }
      }
    })

    this.learningPeriodValue.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val=>{
      
      if(this.rulevarservice.contextShowError.learning == true){
        if(val && val !=0){ 
          this.rulevarservice.contextShowError.learning=false
        }
        else{
          this.rulevarservice.contextShowError.learning=true
        }
      }
      if(val && this.ttlValue.value){ 
        if(val > this.ttlValue.value){
          this.rulevarservice.learningTtlErr.learning=true
          this.rulevarservice.contextValid=false
        }else{
          this.rulevarservice.learningTtlErr.learning=false
          this.rulevarservice.learningTtlErr.ttl=false
          this.rulevarservice.contextValid=true
        }
      }
    })

    this.entryMode.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(mode=>{
      this.resetManualTable()
      this.resetImportedMapedFields()
      this.resetImportedValues()
    })
    this.maxEntry.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(max=>{
      if(this.rulevarservice.intelEditMode){
        if(max < this.rulevarservice.intelEditValue.details.rows){
         this.openPopup()
        }
      }
    })

  }

  openPopup() {
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.Popup, {
      width: '35vw',  
      height: '18vh'     
    });
    this.dialogRef=dialogRef
  }
  popupNo(){
    this.maxEntry.setValue(this.rulevarservice.intelEditValue.context.maxEntry)
    this.dialogRef.close()
  }
  popupYes(){
    this.dialogRef.close()
  }

  createRouteCrumps(){
    if(this.rulevarservice.intelEditMode){
      this.rcrumpService.route_crumps[2] = {
        disp_str:'Edit Intel List',
        routeTo:"intel-list/create",
        callback:this.routeBack,
        isParent:false
      }
    }else{
      this.rcrumpService.route_crumps[2] = {
        disp_str:'Create Intel List',
        routeTo:"intel-list/create",
        callback:this.routeBack,
        isParent:false
      }
    }
  }

  changeTab(index: number) { // Change Tab
    this.rulevarservice.intelSelectedIndex = index;
  }
  listCheck(table,editTable){

//console.log({table})
//console.log({editTable})
    let result = false
    if(table.length != editTable.length){
      return true
    }else{
      Object.keys(table).forEach(key=>{
        Object.keys(table[key]).forEach(val=>{
          if(val !='alias'){
            if(table[key][val] || editTable[key][val]){
              if(table[key][val] != editTable[key][val]){
//console.log(table[key][val],"-->",editTable[key][val])
                result =true
              }
            }
          }
        })
      })
      if(result){
        return true
      }else{
        return false
      }
    }
    
  }

  async postIntelList(){ //Post Intel List
   
    let postvalue=this.rulevarservice.intelForm.getRawValue()
    delete postvalue.createTable.entryMode
    delete postvalue.createTable.remove
    postvalue.createTable.table.forEach(key=>{
      delete key.mappedField
    })
    Object.keys(this.table.controls).forEach(key=>{ //add listname before alias
      // console.log(key,"--->",this.table.get(key.toString()).get('alias').value)
      // this.table.get(key.toString()).get('alias').clearValidators()
      let alias='$'+this.listName.value+'.'+this.table.get(key.toString()).get('alias').value
      // console.log("-->",postvalue.createTable.table[key])
      postvalue.createTable.table[key]['column_alias']=alias
      // console.log({alias})
      // this.table.get(key.toString()).get('alias').setValue(alias)
    })
  
    if(this.rulevarservice.intelEditMode){
      postvalue['list_change']=this.listCheck(postvalue.createTable.table,this.rulevarservice.intelEditValue.createTable.table)
      postvalue['list_id']=this.rulevarservice.intelEditValue.list_id
    }else{
      postvalue['list_change']=false
    }
    postvalue.context['ttl']=parseInt(postvalue.context.ttlValue)*parseInt(postvalue.context.timeUnit)
    postvalue.context['learningPeriod']=parseInt(postvalue.context.learningPeriodValue)*parseInt(postvalue.context.learningUnit)
    // postvalue['file'] = this.rulevarservice.postFile
    //console.log("PostValue --- >",postvalue)
    // this.rulevarservice.intelList.push({"listname":this.listName.value,"platform":this.platform.value,"ttl":this.ttl.value +" " + this.timeUnit.value})
//console.log("PostValue -->",postvalue)

    if(this.table.valid){
//console.log("<---------- INTEL LIST POSTED ---------->")
      if(!this.rulevarservice.intelEditMode){
        await this.ruleService.postNewIntelList.postrequest(postvalue)
            .then((dat: any) => {
              this.mat_spinner_create_state = false;
              if (dat) {
                this.open_toaster('Intel list created', 'success');
                this.ruleService.providerulelist.emitstate = -1;
              }else{
                this.open_toaster('Cannot create intel list', 'failure')
              }
              this.previousClick()
            })
            .catch(err => {
              this.mat_spinner_create_state = false;
              this.open_toaster('Cannot create intel list', 'failure')
            })
        // console.log("<---------- INTEL LIST POSTED ---------->")
      }else{
        await this.ruleService.postEditIntelList.postrequest(postvalue)
        .then((dat: any) => {
          this.mat_spinner_create_state = false;
          if (dat) {
            this.open_toaster('Intel list edited', 'success');
            this.ruleService.providerulelist.emitstate = -1;
          }else{
            this.open_toaster('Cannot edit intel list', 'failure')
          }
          this.previousClick()
        })
        .catch(err => {
          this.mat_spinner_create_state = false;
          this.open_toaster('Cannot edit intel list', 'failure')
        })
        // console.log("<---------- INTEL LIST EDIT POSTED ---------->")
      }
      this.router.navigateByUrl("intel-list");
      }

    
    // this.rulevarservice.setAliasValidators()
  }
  resetTable(){ //reset create table
    for(let i=this.table.controls.length-1;i>=0;i--){
      this.removeDestroy(i)
    }
  }

  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  }
  resetManualTable(){ // reset manual entry table
    for(let i=this.manualTable.controls.length-1;i>=0;i--){
      this.removeAllManualClick(i)
    }
  }

  resetImportedMapedFields(){
    Object.keys(this.table.value).forEach(key=>{
      this.table.get(key.toString()).get('mappedField').setValue('')
    })
  }

  setDefault(){ // set default to all on destroy
    const reset=this.rulevarservice.jsonEdit(this.rulevarservice.defaultIntel)
    this.rulevarservice.intelForm.patchValue(reset)
    this.entryMode.reset()
    this.resetTable()
    this.resetManualTable()
  }

  nextClick(){ // next button click

    if(this.rulevarservice.intelSelectedIndex == 0){ // Context Page
//console.log(this.context)
      this.listName.markAllAsTouched()

      if(this.context.valid && this.rulevarservice.contextValid){
        this.rulevarservice.intelSelectedIndex++
        this.next="SUBMIT"
        this.back="PREVIOUS"
        this.rulevarservice.resetContextErrors() // remove errors
      }
      else{
        // if(!this.listName.valid){
        //   this.rulevarservice.contextShowError.listName=true
        // }
        // else{
        //   this.rulevarservice.contextShowError.listName=false
        // }
        if(!this.ttlValue.valid){
          this.rulevarservice.contextShowError.TTL=true
        }
        else{
          this.rulevarservice.contextShowError.TTL=false
        }
        if(!this.learningPeriodValue.valid){
          this.rulevarservice.contextShowError.learning=true
        }else{
          this.rulevarservice.contextShowError.learning=false
        }
      }
//console.log(this.rulevarservice.intelForm.value)
    }

    else if(this.rulevarservice.intelSelectedIndex == 1){ // Create List Page

//console.log(this.table)

      if(this.table.valid){
        if(!this.checkDuplicates()){
          if(this.entryMode.value === "import"){
            this.addValidators()
          }
          this.postIntelList()
        
          // this.rulevarservice.intelSelectedIndex++ // import page not used
          // this.next="NEXT"
          // this.back="PREVIOUS"
//console.log(this.rulevarservice.intelForm.value)
          
          // this.rulevarservice.addManual()
          if(!this.manualTable.value.length){
//console.log("AddManual----->")
            this.manualTable.push(this.rulevarservice.addManual())
          }
//console.log(this.manualTable)
          this.rulevarservice.createShowError=false
        }
        else{
          this.rulevarservice.createShowError=true
          this.createErrorString=this.rulevarservice.createErrors[103]
//console.log("------Has Duplicate Values------")
        }
      }
      else{
//console.log(this.table.value)
        let empty=[]
        let alias=[]
        let size=[]
        Object.keys(this.table.value).forEach(key=>{
          if(this.table.value[key].fieldName === ''){
            empty.push(this.table.value[key].fieldName)
           
          }else if(this.table.value[key].fieldName.length < 4){
            size.push(this.table.value[key].fieldName)
          }
          if(this.table.value[key].alias === ''){
             alias.push(this.table.value[key].fieldName)
          }
        })
        // console.log({alias})
//console.log({empty})
        if(empty.length){
          this.rulevarservice.createShowError=true
          this.createErrorString=this.rulevarservice.createErrors[101]
          alias=[]
//console.log("------Empty------")
        }
        else if(size.length){
          this.rulevarservice.createShowError=true
          this.createErrorString=this.rulevarservice.createErrors[102]
        }
        // else if(alias.length){
        //   this.rulevarservice.createShowError=true
        //   this.createErrorString=this.rulevarservice.createErrors[104]
          
//console.log("-----Less than 4------")
        // }
        else{
          this.rulevarservice.createShowError=true
          this.createErrorString=this.rulevarservice.createErrors[105]
        }
       
        
      }
      
    }

//     else if(this.rulevarservice.intelSelectedIndex == 2){ //Add Intel Page

//       if(this.entryMode.value === "import"){
//         if(this.table.valid){
//           if(this.rulevarservice.dataTypeError.length === 0){
//             if(!this.checkImporedFields()){
//               this.postIntelList()
//               this.rulevarservice.importIntelError=false
//             }
//             else{
//               this.rulevarservice.importIntelError=true
//               this.importErrorString=this.rulevarservice.importErrorString[101]
// //console.log("-----Duplicates-----")
//             }
//           }
//         }
//         else{
//           this.rulevarservice.importIntelError=true
//           this.importErrorString=this.rulevarservice.importErrorString[102]
// //console.log("-----Empty-----")
//         }
//       }
//       else{
//         if(this.rulevarservice.manualIntel.valid){
//           this.rulevarservice.postFile=this.manualTable.getRawValue()
//           this.rulevarservice.manualIntelError=false
//           this.postIntelList()
//         }
//         else{
//           this.rulevarservice.manualIntelError=true
//         }
//       }
//     }
  }

  addValidators(){ // Add validators to mappedFields after Create
    Object.keys(this.table.controls).forEach(key=>{
      this.table.get(key.toString()).get('mappedField').addValidators(Validators.required),{emitEvent:false};
      this.table.get(key.toString()).get('mappedField').updateValueAndValidity(),{emitEvent:false};
    })
  }
  removeValidators(){
    Object.keys(this.table.controls).forEach(key=>{
      this.table.get(key.toString()).get('mappedField').clearValidators(),{emitEvent:false};
      this.table.get(key.toString()).get('mappedField').updateValueAndValidity(),{emitEvent:false};

    })
  }

  checkDuplicates(){
//console.log(this.table.value)
    // Object.keys(this.table.value).forEach(key=>{
    //   this.table.get(key.toString()).get('fieldName').value
    // })

    const names = this.table.value.map(item => item.fieldName?.trim().toLowerCase());
    return new Set(names).size !== names.length;
  }

  checkImporedFields(){
    const names = this.table.value.map(item => item.mappedField?.trim().toLowerCase());
    return new Set(names).size !== names.length;
  }

  openProperties(i){
    event.stopPropagation()
    this.openprop=true
    this.openIndex=i
    if(this.table.get(i.toString()).get('fieldName').value.length > 0){
      this.dispstr="Properties of "+this.table.get(i.toString()).get('fieldName').value
    }
    else{
      this.dispstr="Properties of Row "+ i.toString()
    }
    this.index=i
//console.log(this.table.get(i.toString()))
  }
  propertyClicked(){
    event.stopPropagation()
  }
  propertyHeader(){
   return Object.keys(this.table.controls).some(key=>{
      if(this.table.get(key.toString()).get('enrichable').value || this.table.get(key.toString()).get('alias').value){
        // console.log(this.table.get(key.toString()).get('enrichable').value)
        return true
      }
    })
  }

  get context(){
    return this.rulevarservice.intelForm.get('context') as UntypedFormGroup
  }
  get listName(){
    return this.context.get('listName')
  }
  get platform(){
    return this.context.get('platform')
  }
  get ttlValue(){
    return this.context.get('ttlValue')
  }
  get timeUnit(){
    return this.context.get('timeUnit')
  }

  get learningPeriodValue(){
    return this.context.get('learningPeriodValue')
  }

  get maxEntry(){
    return this.context.get('maxEntry')
  }

  get createTable(){
    return this.rulevarservice.intelForm.get('createTable') as UntypedFormGroup
  }

  get table(){
    return this.createTable.get('table') as UntypedFormArray
  }

  get entryMode(){
    return this.createTable.get('entryMode')
  }

  get remove(){
    return this.createTable.get('remove')
  }

 get manualTable(){
  return this.rulevarservice.manualIntel.get('manualTable') as UntypedFormArray
 }

 addInit(i){
  if(this.table.controls.length < this.rulevarservice.intelColumnLimit){
    this.table.insert(i+1,this.rulevarservice.addNewTable())
  }
 
  if (this.manualTable.controls.length > 0) { // Dynamically Add formcontrol 
    Object.keys(this.manualTable.controls).forEach(key => {
      const fg = this.manualTable.get(key.toString()) as FormGroup;
      const fieldName = this.table.get((i+1).toString()).get('fieldName')?.value;
      fg.addControl(fieldName, new FormControl(''));
    });
  }
 }


  addClick(i,mode = 'default'){
    // let add:boolean=true
    // if(this.disableInput){
    //   if(this.rulevarservice.intelEditMode){
    //     add=false
    //     this.editClick(i)
    //     if(this.disableInput){
    //       add=false
    //     }else{
    //       add=true
    //     }
    //   }
    // }
    // if(add){
    //   if(this.table.controls.length < this.rulevarservice.intelColumnLimit){
    //     this.table.insert(i+1,this.rulevarservice.addNewTable())
    //   }
    //   if (this.manualTable.controls.length > 0) { // Dynamically Add formcontrol 
    //     Object.keys(this.manualTable.controls).forEach(key => {
    //       const fg = this.manualTable.get(key.toString()) as FormGroup;
    //       const fieldName = this.table.get((i+1).toString()).get('fieldName')?.value;
    //       fg.addControl(fieldName, new FormControl(''));
    //     });
    //   }
    // }

    if(mode === 'keydown'){
      if(i === this.table.controls.length-1){
//console.log("keydown -> ",mode ,"->", i , "->", this.table.controls.length-1)
        let add:boolean=true
        if(this.disableInput){
          if(this.rulevarservice.intelEditMode){
            add=false
            this.mode.mode='add'
            this.mode.i=i
            this.editClick(i)
            if(this.disableInput){
              add=false
            }else{
              add=true
            }
          }
        }
        if(add){
          if(this.table.controls.length < this.rulevarservice.intelColumnLimit){
            this.table.insert(i+1,this.rulevarservice.addNewTable())
          }
          if (this.manualTable.controls.length > 0) { // Dynamically Add formcontrol 
            Object.keys(this.manualTable.controls).forEach(key => {
              const fg = this.manualTable.get(key.toString()) as FormGroup;
              const fieldName = this.table.get((i+1).toString()).get('fieldName')?.value;
              fg.addControl(fieldName, new FormControl(''));
            });
          }
        }
      }
    }else{
      
//console.log("default -> ",mode ,"->", i , "->", this.table.controls.length-1)
      let add:boolean=true
      if(this.disableInput){
        if(this.rulevarservice.intelEditMode){
          add=false
          this.mode.mode='add'
          this.mode.i=i
          this.editClick(i)
          if(this.disableInput){
            add=false
          }else{
            add=true
          }
        }
      }
      if(add){
        if(this.table.controls.length < this.rulevarservice.intelColumnLimit){
          this.table.insert(i+1,this.rulevarservice.addNewTable())
        }
        if (this.manualTable.controls.length > 0) { // Dynamically Add formcontrol 
          Object.keys(this.manualTable.controls).forEach(key => {
            const fg = this.manualTable.get(key.toString()) as FormGroup;
            const fieldName = this.table.get((i+1).toString()).get('fieldName')?.value;
            fg.addControl(fieldName, new FormControl(''));
          });
        }
      }
    }
    
  }
  addManualClick(i){
    if( i <= this.maxEntry.value){
      this.manualTable.insert(i+1,this.rulevarservice.addManual())
    }
//console.log("manualTable --->",this.manualTable)

  }

  removeDestroy(index){
    if(this.table.length>1){
      if (this.manualTable.controls.length > 0) { // Dynamically Remove formcontrol
        Object.keys(this.manualTable.controls).forEach(key => {
          const fg = this.manualTable.get(key.toString()) as FormGroup;
          const fieldName = this.table.get((index).toString()).get('fieldName')?.value;
          fg.removeControl(fieldName);
        });
      }
      this.table.removeAt(index)
    }
  }

  removeClick(index:number){
    let remove:boolean=true
    if(this.disableInput){
      if(this.rulevarservice.intelEditMode){
        remove=false
        this.mode.mode='remove'
          this.mode.i=index
        this.editClick(index)
        if(this.disableInput){
          remove=false
        }else{
          remove=true
        }
      }
    }
    if(remove){
      if(this.table.length>1){
        if (this.manualTable.controls.length > 0) { // Dynamically Remove formcontrol
          // const group=this.manualTable.get('0') as FormGroup
          // group.addControl(this.table.get(i.toString()).get('fieldName')?.value,new FormControl(''))
  //console.log("ADD CONTROL ____---->")
          Object.keys(this.manualTable.controls).forEach(key => {
            const fg = this.manualTable.get(key.toString()) as FormGroup;
  //console.log({fg})
            const fieldName = this.table.get((index).toString()).get('fieldName')?.value;
  //console.log({fieldName})
            fg.removeControl(fieldName);
  //console.log("fg -->",fg)
          });
        }
        this.table.removeAt(index)
        // Object.keys(this.table.value).forEach(key=>{
        //   if(parseInt(key)>=index){
        //     let name= "Column "+(parseInt(key)+1)
        //     this.table.get((key).toString()).get('fieldName').setValue(name)
        //   }
        // })
        
      }
    }
    
  }
  editClick(index){
    if(this.rulevarservice.intelEditValue.details.referenced){
      this.openEditPopup(this.editPopup)
    }else{
      this.openEditPopup(this.editWarnPopup)
    }
  }

  openEditPopup(template) {
    const dialogRef: MatDialogRef<any> = this.matdialog.open(template, {
      width: '37vw',  
      height: '18vh',
    });
    this.dialogRef=dialogRef
  }

  editPopupYes(){
    let empty:number
    this.openIndex=empty
    this.dialogRef.close()
  }
  editWarnPopupYes(){
    this.disableInput=false
    this.editWarn.next('yes')
    this.dialogRef.close()
  }
  editWarnPopupNo(){
    this.disableInput=true
    let empty:number
    // this.openprop=false
    this.openIndex=empty
    // this.editWarn.next('no')
    this.mode.mode=''
    this.mode.i=null
    this.dialogRef.close()
  }

  removeManualClick(i){ // remove manual entry rows
    if(this.manualTable.length>1){
      this.manualTable.removeAt(i)
    }
  
  }
  removeAllManualClick(i){ // remove All manual entry rows
    
      this.manualTable.removeAt(i)
    
  
  }

  addControls(){
    Object.keys(this.table.controls).forEach(key=>{
      // console.log("FieldName --->",this.table.get(key.toString()).get('fieldName').value)
      return this.table.get(key.toString()).get('fieldName').value
    })
  }

  
  emptyProp(){
    let empty:number
    this.openIndex=empty
    // console.log(this.openIndex)
  }
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  resetImportedValues(){
    this.rawData=[]
    this.rulevarservice.postFile=[]
    this.rulevarservice.allFields=[]
    this.rulevarservice.importedFields=[]
    this.rulevarservice.importColumType={}
  }


  onFileChange(evt: any): void { // Read uploaded file

    Object.keys(this.table.controls).forEach(key=>{
      this.table.get(key.toString()).get('mappedField').setValue('')
    })

    const target: DataTransfer = <DataTransfer>(evt.target);
    // console.log(target.files[0].name)
    const extension = target.files[0].name.split(".").pop().toLowerCase();
//console.log({extension})
    if (target.files.length !== 1) {
//console.log('Please upload a single Excel file.');
      return;
    }

    if(extension != "csv"){ // if XLSX

      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
//console.log({e})
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
//console.group('Binary')
//console.log({binaryStr})
//console.log({workbook})
//console.log({sheetName})
//console.log({sheet})
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

        

        this.rawData = jsonData;
        this.rulevarservice.postFile=[]
        this.rulevarservice.postFile=jsonData
//console.log(this.rawData);
        this.rulevarservice.allFields=[]
        this.rulevarservice.importedFields=[]
        this.rulevarservice.importedFields=this.getHeaders(this.rawData[0])
        this.rulevarservice.allFields=this.getHeaders(this.rawData[0])
        const columnTypes = this.getColumnTypes(sheet);
        this.rulevarservice.importColumType={}
        this.rulevarservice.importColumType=this.getColumnTypes(sheet)
//console.log('Column Types:', columnTypes);
        const updatedData = this.rawData.map((row, index) => ({
          '#': index + 1,   // add serial number (1-based)
          ...row            // spread original row
        }));

        // ✅ Update local variables
        this.rawData = updatedData;
        
        // this.errors = this.validateHeaders(jsonData);

        // if (this.errors.length === 0) {
        //   this.parsedData = this.mapToModel(jsonData);
        // } else {
        //   this.parsedData = [];
        // }
        // this.parsedData = jsonData
      };
      reader.readAsBinaryString(target.files[0]);
    }
    else{ // IF CSV
          const files = evt.srcElement.files;

        this.ngxCsvParser.parse(files[0], {
          header: true,          // use first row as headers
          delimiter: ',',        // CSV delimiter
          encoding: 'utf8'
        }).pipe().subscribe({
          next: (result: Array<any>) => {
//console.log('Parsed result:', result);
            let csvRecords = result;
            this.rulevarservice.postFile=[]
            this.rulevarservice.postFile=result
            this.rawData=result
            let columnDataTypes = this.detectColumnDataTypes(result);
            this.rulevarservice.importColumType={}
            this.rulevarservice.importColumType = columnDataTypes

//console.log('Detected column types:', columnDataTypes);
            this.rulevarservice.importedFields=[]
            this.rulevarservice.importedFields=Object.keys(result[0]);
              // ✅ Add serial number column
          const updatedData = result.map((row, index) => ({
            '#': index + 1,   // add serial number (1-based)
            ...row            // spread original row
          }));

          // ✅ Update local variables
          this.rawData = updatedData;

          // ✅ Add '#' in front of headers
          // this.rulevarservice.importedFields = ['#', ...Object.keys(result[0])];

//console.log('Headers:', this.rulevarservice.importedFields);
//console.log('Updated Data:', this.rawData);
          },
          error: (error: NgxCSVParserError) => {
//console.error('Error parsing CSV:', error);
          }
        });
      
    }
    // console.log(this.rawData);
  }
   /**
   * 🔎 Detects the datatype of each column
   */
   detectColumnDataTypes(records: any[]): { [key: string]: string } {
    if (!records || records.length === 0) return {};

    const sampleSize = Math.min(10, records.length); // use first 10 rows
    const sample = records.slice(0, sampleSize);
    const types: { [key: string]: string } = {};

    Object.keys(records[0]).forEach((col) => {
      const values = sample
        .map(r => r[col])
        .filter(v => v !== undefined && v !== null && v !== '');

      types[col] = this.inferType(values);
    });

    return types;
  }

  /**
   * 🧠 Helper to infer type of given column values
   */
  inferType(values: any[]): string {
    if (!values.length) return 'text';

    const isNumber = values.every(v => !isNaN(v) && v.trim() !== '');
    if (isNumber) return 'number';

    const isBoolean = values.every(v =>
      ['true', 'false', '1', '0'].includes(v.toString().toLowerCase())
    );
    if (isBoolean) return 'boolean';

    const looksLikeDate = (v: string) =>
    /^\d{4}-\d{2}-\d{2}$/.test(v) || /^\d{2}\/\d{2}\/\d{4}$/.test(v);

    const allDate = values.every(v => looksLikeDate(v) && !isNaN(Date.parse(v)));
    if (allDate) return 'date';

    return 'text';
  }
  
  // getColumnTypes(sheet: XLSX.WorkSheet): Record<string, string> {
  //   const range = XLSX.utils.decode_range(sheet['!ref']!);
  //   const columnTypes: Record<string, string> = {};

  //   for (let C = range.s.c; C <= range.e.c; ++C) {
  //     let colLetter = XLSX.utils.encode_col(C);
  //     console.log({colLetter})
  //     let types: Set<string> = new Set();

  //     for (let R = range.s.r + 1; R <= range.e.r; ++R) { // Skip header row
  //       const cellAddress = { c: C, r: R };
  //       const cellRef = XLSX.utils.encode_cell(cellAddress);
  //       const cell = sheet[cellRef];

  //       if (cell && cell.t) {
  //         types.add(cell.t); // 's' = string, 'n' = number, 'b' = boolean, 'd' = date, 'e' = error
  //       }
  //     }

  //     // Decide dominant type
  //     const typeArray = Array.from(types);
  //     let type = 'unknown';
  //     if (typeArray.length === 1) type = typeArray[0];
  //     else if (typeArray.includes('s')) type = 's';
  //     else if (typeArray.includes('n')) type = 'n';

  //     // Convert type symbol to readable label
  //     const readable = {
  //       s: 'text',
  //       n: 'number',
  //       b: 'boolean',
  //       d: 'date',
  //       e: 'error',
  //       unknown: 'unknown'
  //     };

  //     columnTypes[colLetter] = readable[type as keyof typeof readable];
  //   }

  //   return columnTypes;
  // }
  getColumnTypes(sheet: XLSX.WorkSheet): Record<string, string> {
    const range = XLSX.utils.decode_range(sheet['!ref']!);
    const columnTypes: Record<string, string> = {};
  
    // Extract header names from the first row
    const headerRow = range.s.r; // usually row 0
    const headers: Record<number, string> = {};
  
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = { c: C, r: headerRow };
      const cellRef = XLSX.utils.encode_cell(cellAddress);
      const cell = sheet[cellRef];
      const headerName = cell ? String(cell.v).trim() : `Column${C + 1}`;
      headers[C] = headerName || `Column${C + 1}`;
    }
  
    // Loop through columns
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let types: Set<string> = new Set();
  
      for (let R = range.s.r + 1; R <= range.e.r; ++R) { // Skip header row
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = sheet[cellRef];
  
        if (cell && cell.t) {
          types.add(cell.t); // 's' = string, 'n' = number, 'b' = boolean, etc.
        }
      }
  
      // Determine dominant type
      const typeArray = Array.from(types);
      let type = 'unknown';
      if (typeArray.length === 1) type = typeArray[0];
      else if (typeArray.includes('s')) type = 's';
      else if (typeArray.includes('n')) type = 'n';
  
      // Convert to readable label
      const readable = {
        s: 'text',
        n: 'number',
        b: 'boolean',
        d: 'date',
        e: 'error',
        unknown: 'unknown'
      };
  
      const headerName = headers[C];
      columnTypes[headerName] = readable[type as keyof typeof readable];
    }
  
    return columnTypes;
  }
  

  validateHeaders(data: any[]): string[] {
    const fileHeaders = Object.keys(data[0] || {});
    const missing = this.requiredHeaders.filter(h => !fileHeaders.includes(h));
    return missing.length > 0 ? [`Missing headers: ${missing.join(', ')}`] : [];
  }

  mapToModel(data: any[]) {
    // return data.map(row => ({
    //   Service: row['service'],
    //   Count: Number(row['count']),
    // }));
    return data
  }

  getHeaders(rawData:{}){
    // console.log({rawData})
    let header=[]
    Object.keys(rawData).forEach(key=>{
     header.push(key)
    })
    return header
  }

  

  previousClick(){ // Previous click
    if(this.rulevarservice.intelSelectedIndex){
      this.removeValidators()
      this.rulevarservice.intelSelectedIndex--
      if(this.rulevarservice.intelSelectedIndex ==0){
        this.back="CANCEL"
      }
      else{
        this.back="PREVIOUS"
      }
      this.next="NEXT"
    }else if(this.rulevarservice.intelSelectedIndex == 0){
      this.router.navigateByUrl("intel-list");
    }
  }
  ngOnDestroy(){
    this.removeValidators()
    this.rulevarservice.createShowError=false
    this.rulevarservice.importIntelError=false
    this.rulevarservice.manualIntelError=false
    this.rulevarservice.intelEditMode=false
    this.rulevarservice.contextValid=true
    this.rulevarservice.resetContextErrors()
    this.setDefault()
    this.rulevarservice.isIntel=false
    this.changeTab(0)
    this.rulevarservice.ruleLandingchangeTab(2)
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    
  }
}
